import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Per-trait marking cell content for one student/trait pair — plugged into
 * a reusable <Table> column's `render(student, studentIndex)`.
 */
export const getTraitCellContent = ({
  studentTrait,
  student,
  eventInfo,
  traitChangeHandler,
  editableStudentId,
  studentIndex,
}) => {
  const traitHash = {};
  student.marks_data.forEach((item) => (traitHash[item.trait_id] = item));
  const existingMark = traitHash[studentTrait.subject_trait.id];
  const isLetterOrText =
    eventInfo.grade_scheme.type === 'Letters' || eventInfo.grade_scheme.type === 'Text';

  if (existingMark) {
    if (editableStudentId === student.id) {
      return isLetterOrText ? (
        <select
          onChange={(event) =>
            traitChangeHandler(event, student.id, studentTrait.subject_trait.id, studentIndex)
          }
          value={existingMark.option_id || ''}
          className="form-select form-control cursor-pointer"
          name="option_id"
          style={{ width: 150 }}
          data-placeholder="Select organization"
        >
          <option value={''}>Options</option>
          {studentTrait.grade_scheme.options.map((Option, idx) => (
            <option value={Option.id} key={idx}>
              {Option.option_name}
            </option>
          ))}
        </select>
      ) : (
        <Form.Control
          type="number"
          name="option_value"
          onChange={(event) =>
            traitChangeHandler(event, student.id, studentTrait.subject_trait.id, studentIndex)
          }
        />
      );
    }

    return student.marks_data.map((item) =>
      item.trait_id === studentTrait.subject_trait.id ? item.option_value : ''
    );
  }

  return isLetterOrText ? (
    <select
      onChange={(event) =>
        traitChangeHandler(event, student.id, studentTrait.subject_trait.id, studentIndex)
      }
      className="form-select form-control cursor-pointer"
      name="option_id"
      style={{ width: 150 }}
      data-placeholder="Select organization"
    >
      <option value={0}>Options</option>
      {studentTrait.grade_scheme &&
        studentTrait.grade_scheme.options.map((Option, idx) => (
          <option value={Option.id} key={idx}>
            {Option.option_name}
          </option>
        ))}
    </select>
  ) : (
    <Form.Control
      type="text"
      name="option_value"
      onChange={(event) =>
        traitChangeHandler(event, student.id, studentTrait.subject_trait.id, studentIndex)
      }
    />
  );
};
